export const errorTypes = {
	COMPONENT_ERROR_THROWN: 'SEISMIC_COMPONENT_ERROR_THROWN'
};

// Public action types
export const actionTypes = {
	COMPONENT_CONNECTED: 'SEISMIC_COMPONENT_CONNECTED',
	COMPONENT_DISCONNECTED: 'SEISMIC_COMPONENT_DISCONNECTED',
	COMPONENT_BOOTSTRAPPED: 'SEISMIC_COMPONENT_BOOTSTRAPPED',
	COMPONENT_PROPERTY_CHANGED: 'SEISMIC_COMPONENT_PROPERTY_CHANGED',
	COMPONENT_RENDERED: 'SEISMIC_COMPONENT_RENDERED',
	COMPONENT_DOM_READY: 'SEISMIC_COMPONENT_DOM_READY',
	COMPONENT_PROPERTY_UPDATE_REQUESTED: 'SEISMIC_COMPONENT_PROPERTY_UPDATE_REQUESTED',
	COMPONENT_RENDER_REQUESTED: 'SEISMIC_COMPONENT_RENDER_REQUESTED',
	COMPONENT_DOM_TREE_READY: 'SEISMIC_COMPONENT_DOM_TREE_READY',
	COMPONENT_TREE_RENDERED: 'SEISMIC_COMPONENT_TREE_RENDERED',
	COMPONENT_ACTION_DISPATCHED: 'SEISMIC_COMPONENT_ACTION_DISPATCHED',
	COMPONENT_ERROR_THROWN: errorTypes.COMPONENT_ERROR_THROWN,
	COMPONENT_INTERACTIVE: 'SEISMIC_COMPONENT_INTERACTIVE'
};

export const locations = {
	EFFECT: 'SEISMIC_LOCATION_EFFECT',
	EVENT: 'SEISMIC_LOCATION_EVENT',
	INITIAL_STATE: 'SEISMIC_LOCATION_INITIAL_STATE',
	INTERCEPTOR: 'SEISMIC_LOCATION_INTERCEPTOR',
	LIFECYCLE: 'SEISMIC_LOCATION_LIFECYCLE',
	PROPERTY: 'SEISMIC_LOCATION_PROPERTY',
	RENDERER: 'SEISMIC_LOCATION_RENDERER',
	TRANSFORM_STATE: 'SEISMIC_LOCATION_TRANSFORM_STATE',
	VIEW: 'SEISMIC_LOCATION_VIEW'
};

export const COMPONENT_ID_ATTRIBUTE = 'component-id';
export const NOW_ID_PROP = 'nowId';
export const DISCONNECTED_TIME = Symbol('SEISMIC_COMPONENT_DISCONNECTED_TIME');

export const domainSeparationProperties = {
	NOW_DS_RECORD_TABLE: 'nowDsRecordTable',
	NOW_DS_RECORD_ID: 'nowDsRecordId',
	NOW_DS_DOMAIN_ID: 'nowDsDomainId',
	NOW_DS_DOMAIN_SCOPE: 'nowDsDomainScope'
};

export const CREATE_REF_SYMBOL = Symbol('__CREATE_REF_SYMBOL__');
export const CREATE_REF_SUBSCRIBE_SYMBOL = Symbol('__CREATE_REF_SUBSCRIBE_SYMBOL__');
export const CREATE_REF_COMP_PROPS_SUBSCRIPTIONS_SYMBOL = Symbol(
	'__CREATE_REF_COMP_PROPS_SUBSCRIPTIONS_SYMBOL__'
);

//tracing
export const ACTIVE_SPAN = Symbol('__ACTIVE_SPAN__');
export const SPAN_KIND_CLIENT = 3;
export const SPAN_FOR_COMPONENT_ERROR_THROWN = 'ERROR_THROWN';
export const SPAN_FOR_DISPATCH = 'ACTION_DISPATCH';
export const SPAN_ATTR_DISPATCH_ACTION_TYPE = 'actionType';
export const SPAN_ATTR_DISPATCH_MESSAGE = 'message';
